import { render } from "./SidebarNavPatient.vue?vue&type=template&id=b12971f6"
import script from "./SidebarNavPatient.vue?vue&type=script&lang=js"
export * from "./SidebarNavPatient.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__